import { ApiCall } from "../helper/axios";
class SemrushService {
    /**
     * Fetch Semrush dashboard data for a given root domain or URL.
     * The backend hits the SEMrush traffic + backlink APIs which are paid —
     * call this only when the user explicitly clicks Search.
     */
    async getDashboard(search, searchType, token) {
        const response = await ApiCall("POST", "/api/semrush/dashboard", { search, search_type: searchType }, {
            Authorization: token,
        });
        if (response && "data" in response && response.status === 200) {
            return response.data;
        }
        throw new Error("Failed to fetch Semrush dashboard");
    }
    /**
     * Re-open a previously stored Semrush report by its record id (used when
     * a shared report link is opened). Restores the dashboard from the DB.
     */
    async getRecord(recordId, token) {
        const response = await ApiCall("GET", `/api/semrush/record/${recordId}`, "", { Authorization: token });
        if (response && "data" in response && response.status === 200) {
            return response.data;
        }
        throw new Error("Failed to fetch Semrush report");
    }
    /**
     * Share a stored report with the selected users by email.
     */
    async shareReport(recordId, userIds, token) {
        const response = await ApiCall("POST", "/api/semrush/share", { record_id: recordId, user_ids: userIds }, { Authorization: token });
        if (response && "data" in response) {
            return response.data;
        }
        throw new Error("Failed to share Semrush report");
    }
    /**
     * Fetch active portal users for the share dropdown (name + email).
     */
    async getShareableUsers(token) {
        const response = await ApiCall("GET", "/api/users?status=active&limit=500", "", { Authorization: token });
        if (response && "data" in response && response.data?.success) {
            const users = response.data?.data?.users || [];
            return users
                .map((u) => ({
                id: String(u._id ?? u.id ?? ""),
                name: [u.first_name, u.last_name].filter(Boolean).join(" ").trim() || u.email,
                email: u.email || "",
            }))
                .filter((u) => u.id && u.email);
        }
        return [];
    }
}
export const semrushService = new SemrushService();
